import { getGDPR } from "@mp-commons/modules/ads/GDPR.js";
import { UserAdsData } from "@mp-commons/modules/ads/adcall/composable/UserAdsData.js";
import { AmazonBidBehaviour, AmazonBidder } from "@mp-commons/modules/ads/prebid/AmazonBidder.js";
import { IASHB } from "@mp-commons/modules/ads/prebid/IASHB.js";
import { GroupedPrebidModulesWithAdsManagerPostOps } from "@mp-commons/modules/ads/prebid/GroupedPrebidModules.js";
import { PrebidModule } from "@mp-commons/modules/ads/prebid/PrebidModule.js";
import { PrebidJS } from "@mp-commons/modules/ads/prebid/PrebidJS.js";
import { PianoModule } from "@mp-commons/modules/ads/prebid/PianoModule.js";
import { CP_AdvSiteName, CP_EmbedType } from "@mp-commons/modules/ads/adcall/CustomParams.js";


//3597
/**
 * Builds and configures a set of prebid modules for ad bidding, based on provided parameters.
 *
 * @param window - The browser window object, used for module initialization.
 * @param userData - User-specific ad data required for targeting and personalization.
 * @param amz - Optional Amazon bidder configuration, including publisher ID and bid behaviour.
 * @param iasIds - Optional IAS bidder configuration, including publisher and account IDs.
 * @param prebidjs - Optional Prebid.js configuration, including enablement flag and site name.
 * @param piano - Optional Piano module configuration, including enablement flag.
 * @param timeout - Timeout in milliseconds for bidder initialization (default: 1000).
 * @returns A grouped prebid module containing all configured ad bidding modules.
 */
export function PrebidBuilder(window: Window, site: CP_AdvSiteName, playerType: CP_EmbedType, userData: UserAdsData, amz?: { pubId: string, behaviour: AmazonBidBehaviour }, iasIds?: { pubId: string, anId: string },
    prebidjs?: { enabled: boolean },
    piano?: { enabled: boolean }, timeout: number = 1000): PrebidModule {

    const gdpr = getGDPR();

    const grouped = new GroupedPrebidModulesWithAdsManagerPostOps();

    if (amz?.pubId && amz.pubId != "") {
        const a9 = new AmazonBidder(timeout, amz.pubId, userData, window, playerType, amz.behaviour, gdpr);
        grouped.addModule(a9);
        if (amz.behaviour == AmazonBidBehaviour.ALLOW_PRELOADING_NEXT_BID) {
            setTimeout(() => {
                a9.preloadNextBid();
            }, 0)
        }
    }

    if (iasIds && iasIds.pubId != "" && iasIds.anId != "") {
        //const ias = new IASHB(window,"930840","931226",timeout);
        const ias = new IASHB(window, iasIds.pubId, iasIds.anId, timeout);
        grouped.addModule(ias);
    }

    if (prebidjs && prebidjs.enabled) {
        const prebidjsModule = new PrebidJS(site, window, userData, gdpr)
        grouped.addModule(prebidjsModule)
    }


    if (piano && piano.enabled) {
        const pianoModule = new PianoModule(window, site)
        grouped.addModule(pianoModule)
    }

    return grouped;
}